module.exports = __webpack_public_path__ + "media/images/sp/stores/asakusa/asakusa_sns_04-84ce376b710ab0bb43c0c80efe46f966.jpg";